<template>
  <div>
    <van-row>
      <van-col :span="24" style="text-align: center;">
        <img src="@/assets/mlogo.png" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <van-form @submit="handleLogin">
          <van-field
            v-model="form.username"
            name="用户名"
            label="用户名"
            placeholder="用户名"
            :rules="[{ required: true, message: '请输入用户名' }]"
          />
          <van-field
            v-model="form.password"
            type="password"
            name="密码"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请输入密码' }]"
          />
          <div style="margin: 16px;">
            <van-button :loading="loading" round block type="info" native-type="submit">
              登录
            </van-button>
          </div>
        </van-form>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    handleLogin() {
      this.loading = true
      this.$store.dispatch('user/login', this.form)
        .then(() => {
          this.$router.push({ path: '/dashboard'}, () => {})
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login.vue